export const TruncatedText = ({
  text,
  maxLength,
}: {
  text: string;
  maxLength: number;
}) => {
  return (
    <span
      title={text.length > maxLength ? text : undefined}
      style={{
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {text.length > maxLength ? `${text.substring(0, maxLength)}...` : text}
    </span>
  );
};
